import { useAppContext } from "../context/appContext";

export default function Alert() {
  const { alertType, alertText } = useAppContext();
  return <div className={`alert-${alertType} font-semibold`}>{alertText}</div>;
}
